<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本参数" name="first">
          <div class="scroll_content">
            <el-form-item label="素材标题" style="width:500px;">
              <el-input v-model="form.title" clearable placeholder="请填写素材标题" disabled></el-input>
            </el-form-item>
            <el-form-item label="素材类别" style="width:500px;">
              <el-select disabled v-model="form.industry" clearable>
                <el-option-group
                  v-for="(item, index) in categoryArr"
                  :key="index"
                  :label="item.name"
                >
                  <el-option
                    v-for="(itemChild, indexChild) in item['child']"
                    :key="indexChild"
                    :label="itemChild.name"
                    :value="itemChild.id"
                  ></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="图标格式" v-show="iconShow">
              <el-checkbox-group disabled v-model="format">
                <el-checkbox
                  v-for="(item, index) in iconFormat"
                  :key="index"
                  :label="item.id"
                >{{ item.title }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="源码类别" v-if="form.parentType > 0">
              <el-select disabled v-model="form.parentType" clearable>
                <el-option
                  v-for="(item, index) in sourceArr"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="积分">
              <el-input-number disabled v-model="form.price" controls-position="right" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="是否原创">
              <el-radio-group disabled v-model="form.isOriginal">
                <el-radio label="0">非原创</el-radio>
                <el-radio label="1">原创</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-tab-pane>
        <el-tab-pane label="内容描述" name="second">
          <div class="scroll_content">
            <el-scrollbar class="page-component__scroll">
              <div class="dialog_content_tmp" v-highlight v-html="form.content"></div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-tab-pane label="预览图片" name="third">
          <div class="scroll_content">
            <el-scrollbar class="page-component__scroll">
              <div v-if="srcList.length > 0">
                <el-row v-for="(item, index) in picArr" :key="index" style="margin-bottom: 20px;">
                  <el-col :span="6" v-for="(childItem, childIndex) in item" :key="childIndex">
                    <div class="image">
                      <el-card :body-style="{ padding: '0px' }">
                        <!-- <img :src="childItem.image" /> -->
                        <el-image :src="childItem.image" :preview-src-list="srcList"></el-image>
                        <div style="padding: 5px 10px; text-align:center;">
                          <span>{{ childItem.name }}</span>
                        </div>
                      </el-card>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="noResult" v-else>暂无预览图片</div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传文件" name="forth">
          <div class="download_content">
            <el-scrollbar class="page-component__scroll">
              <div v-if="hasDownload">
                <el-table
                  :data="downloadLocal"
                  border
                  style="width: 100%"
                  v-if="downloadLocal.length > 0"
                >
                  <el-table-column label="下载地址">
                    <span>本地下载</span>
                  </el-table-column>
                  <el-table-column label="文件大小" prop="fileSize" width="100" align="center"></el-table-column>
                  <el-table-column label="下载" width="200">
                    <template slot-scope="scope">
                      <el-button type="primary" size="medium" @click="downloadFile(scope.row)">下载</el-button>
                      <el-button
                        type="success"
                        size="medium"
                        v-if="demo.isDemo.toString() == '1'"
                        @click="showDemo"
                      >模板预览</el-button>
                      <el-button type="success" size="medium" disabled v-else>模板预览</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="ClearsH1"></div>
                <el-table
                  :data="downloadWeb"
                  border
                  style="width: 100%"
                  v-if="downloadWeb.length > 0"
                >
                  <el-table-column label="下载地址" prop="webName"></el-table-column>
                  <el-table-column label="访问密码" prop="pwd" width="100" align="center"></el-table-column>
                  <el-table-column label="下载" width="200">
                    <template slot-scope="scope">
                      <el-button type="primary" size="medium" @click="openPanFile(scope.row)">下载</el-button>
                      <el-button
                        type="success"
                        size="medium"
                        v-if="demo.isDemo.toString() == '1'"
                        @click="showDemo"
                      >模板预览</el-button>
                      <el-button type="success" size="medium" disabled v-else>模板预览</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="noResult" v-else>暂无文件</div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
// 加载api
import { getArtInfo } from "../../../../api/art";
// 加载函数
import { urlEncode } from "../../../../utils/fn";
export default {
  name: "template_form",
  props: {
    artId: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    // 获取文章详情
    this.getArtDetail();
  },
  data() {
    return {
      loading: true,
      activeName: "first",
      categoryArr: [],
      typeChildArr: {},
      iconFormat: [],
      format: [],
      iconShow: false,
      sourceArr: [],
      sourceShow: false,
      picArr: [],
      srcList: [],
      downloadLocal: [],
      downloadWeb: [],
      hasDownload: false,
      demo: {},
      form: {
        title: "",
        industry: "",
        parentType: "",
        typeChild: "",
        language: "",
        price: 0,
        isOriginal: "0",
        content: ""
      }
    };
  },
  methods: {
    // 获取文章详情
    getArtDetail() {
      this.initData();
      if (this.artId == 0) {
        return;
      }
      getArtInfo({ artID: this.artId, type: "material" }).then(res => {
        if (res.status == 200) {
          this.form.title = res.data.artInfo.title;
          this.form.industry = res.data.artInfo.artTypeID;
          this.form.typeChild = res.data.artInfo.type;
          this.sourceArr = res.data.artTypeParentInfo;
          this.form.parentType = res.data.artInfo.type;
          // 图标类别和源码类别
          if (res.data.formatArr["checked"].length > 0) {
            this.iconShow = true;
            this.format = res.data.formatArr["checked"];
            this.iconFormat = res.data.formatArr["list"];
          } else {
            this.iconShow = false;
          }
          this.form.price = res.data.artInfo.price;
          this.form.isOriginal = res.data.artInfo.isOriginal.toString();
          this.form.content = res.data.artInfo.content;
          this.categoryArr = res.data.categoryArr;
          this.picArr = this.groupPic(res.data.pic);
          this.demo = res.data.demo;
          this.groupDownload(res.data.download);
          this.loading = false;
        } else {
          this.$notify({
            title: "警告",
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 初始化内容
    initData() {
      this.typeChildArr = {};
      this.srcList = [];
      this.downloadLocal = [];
      this.hasDownload = false;
    },
    // 组合图片
    groupPic(picArr) {
      let resultArr = [];
      let picList = [];
      if (picArr.length > 0) {
        let i = 1;
        picArr.forEach(element => {
          picList.push(element);
          this.srcList.push(element.image);
          if (i % 4 == 0) {
            resultArr.push(picList);
            picList = [];
          }
          i++;
        });
      }
      if (picList.length < 4) {
        resultArr.push(picList);
      }

      return resultArr;
    },
    // 整理下载地址
    groupDownload(download) {
      if (download.local != undefined) {
        this.hasDownload = true;
        this.downloadLocal = download.local;
      }
      if (download.web != undefined) {
        this.hasDownload = true;
        // this.downloadWeb = download.web;
        let downloadWeb = download.web;
        this.downloadWeb = [];
        for (let i in downloadWeb) {
          this.downloadWeb.push(downloadWeb[i]);
        }
      }
    },
    // 下载文件
    downloadFile(row) {
      let downloadurl = row.downloadUrl;
      let token = localStorage.getItem("token");
      downloadurl += "&token=" + urlEncode(token);
      window.location = downloadurl;
      return false;
    },
    // 下载文件
    openPanFile(row) {
      window.open(row.url);
      return false;
    },
    // 预览文件
    showDemo() {
      if (this.demo.demoUrl != "") {
        window.open(this.demo.demoUrl);
        return false;
      } else {
        this.$notify({
          title: "警告",
          message: "未找到预览文件",
          type: "warning"
        });
      }
    }
  },
  watch: {
    artId() {
      this.loading = true;
      // 获取文章详情
      this.getArtDetail();
    }
  }
};
</script>

<style scoped>
.download_content {
  height: 400px;
  overflow: hidden;
}

.dialog_content_tmp {
  line-height: 25px;
}

.scroll_content .image {
  width: 98%;
  overflow: hidden;
}

.scroll_content .image img {
  width: 100%;
}
</style>